
import { getUserData } from "../utils/authStorage";
import AdminDashboard from "./AdminDashboard";
import OrganizationDashboard from "./OrganizationDashboard";
import UserDashboard from "./UserDashboard";


const DashboardContainer = ({ isSidebarOpen }) => {
  const userData = getUserData();
  const user = userData?.user || userData?.data || userData || {};
  const userType = String(user?.user_type || user?.type || "").toLowerCase();

  switch (userType) {
    case "admin":
      return <AdminDashboard isSidebarOpen={isSidebarOpen} />;

    case "org":
      return <OrganizationDashboard isSidebarOpen={isSidebarOpen} />;

    case "subordinate":
      return <UserDashboard isSidebarOpen={isSidebarOpen} />;
    

    default:
      return (
        <div className="dashboard-container">
          <h3>No dashboard available for this role</h3>
        </div>
      );
  }
};

export default DashboardContainer;
